import {Building, getAllBuildings, getBuildingEntities} from '../../data';
import {getFallbackBuildingForNewMeeting} from '../meetings';
import createCachedSelector from 're-reselect';
import {RootState} from '../../rootReducer';

export const getManualRoomSelectionBuilding = createCachedSelector(
  getAllBuildings,
  getBuildingEntities,
  (state: RootState, {selectedDate, buildingId}: {selectedDate?: string; buildingId: string}) => {
    if (!selectedDate) {
      return;
    }
    return {
      fallbackBuilding: getFallbackBuildingForNewMeeting(state, selectedDate),
      buildingId,
    };
  },
  (allBuildings, buildingEntities, fallbackData): Building | undefined => {
    if (!buildingEntities || !fallbackData) {
      return;
    }

    return buildingEntities[fallbackData.buildingId] ?? fallbackData.fallbackBuilding ?? allBuildings[0];
  },
)((_state, {selectedDate, buildingId}) => `${selectedDate}:${buildingId}`);
